import React, { useState } from "react";
import { useWatchState, setState } from "@/store";
import { Upload } from "@/components";
import { checkResult, avatar } from "@/common";
import { BaseService, uploadUrl } from "@/service";
import { Modal, Button, Input, Select } from "antd";
import "./style.less";

const InputGroup = Input.Group;
const { Option } = Select;

const App = () => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(undefined);
  const [sex, setSex] = useState(1);
  const [nickname, setNickname] = useState(undefined);
  const [phone, setPhone] = useState(undefined);

  const [[{ userSet }]] = useWatchState(["i18n"]);
  const [
    [{ title, show, hide, width = 300, UPLOAD_SERVER_HOST }],
    [userInfo = {}, setUserInfo],
  ] = useWatchState(["modal.userSet", "user.info"]);

  const onSign = async () => {
    setLoading(true);
    try {
      let data = {};
      if (name) data.name = name;
      if (nickname) data.nickname = nickname;
      if (sex) data.sex = sex;
      if (phone) data.tel = phone;
      if (userInfo.avatar) data.avatar = userInfo.avatar;
      const addRes = await BaseService.put({
        table: "thtt_user",
        where: { user_id: userInfo.user_id },
        data,
      });
      setLoading(false);
      if (!checkResult(addRes)) return;
      const newUser = { ...userInfo, ...data };
      setUserInfo(newUser);
      sessionStorage.setItem("user", JSON.stringify(newUser));
      hide();
    } catch (error) {
      setLoading(false);
    }
  };

  const onUploadFileFinish = (e) => {
    setState("user.info.avatar", e.file.response.files[0].url);
  };

  return (
    <Modal
      className="modal-userSet"
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      onCancel={hide}
      footer={false}
    >
      <div className="child-top-sm p-sm-lr">
        <Upload
          style={{ minWidth: "100px", borderRadius: "50%" }}
          name="files"
          accept=".png,.jpg,.jpeg"
          onFinish={onUploadFileFinish}
          action={uploadUrl}
          listType="picture-card"
          showUploadList={false}
        >
          <img src={avatar(userInfo.avatar, UPLOAD_SERVER_HOST)} alt="" />
        </Upload>
        {/*<Input
          placeholder={userSet.nicknamePlaceholder}
          defaultValue={userInfo.nickname}
          onChange={(e) => setNickname(e.target.value)}
  />*/}
        <Input
          defaultValue={userInfo.name}
          placeholder={userSet.namePlaceholder}
          onChange={(e) => setName(e.target.value)}
        />
        {/*<Input
          defaultValue={userInfo.tel || userInfo.account}
          placeholder={userSet.telPlaceholder}
          onChange={(e) => setPhone(e.target.value)}
  />*/}
        <div className="modal-userSet__btn child-left-sm flex">
          <Button type="default" onClick={hide} loading={loading}>
            {userSet.cancel}
          </Button>
          <Button className="full" onClick={onSign} loading={loading}>
            {userSet.confirm}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default App;
